import React from "react";

const LatestResearch = () => {
  const researchItems = [
    {
      title:
        "Timing Games on Solana: Validator Incentives, Network Impacts, and Agave's Hidden Inefficiencies",
      description:
        "Our team at Chorus One has been closely following the recent discussions around timing games on Solana, and we decided to run experiments to better understand the implications. We’ve documented our findings in this research article.",
    },
    {
      title:
        "Thoughts on BAM, the New Block Building Architecture Introduced by Jito",
      description:
        "This week, Jito, a core piece in Solana’s infrastructure, announced the Block Assembly Marketplace (BAM). In this article, we’ll explore what’s changing, what it means for the network, validators, and users, and the challenges ahead.",
    },
    {
      title: "Distilling Information from Alpenglow Consensus",
      description:
        "Solana remains one of the fastest and most adopted blockchains in the crypto ecosystem. In this context, we view Alpenglow as a bold and necessary evolution in the design of Solana’s consensus architecture.",
      highlight: true,
    },
  ];

  return (
    <section className="px-6 py-20 text-gray-900 bg-white md:px-16 lg:px-28">
      <div className="mx-auto max-w-7xl">
        {/* Section Title */}

        <h2 className="text-[43px] font-medium leading-[50px] text-center text-transparent bg-clip-text bg-gradient-to-r from-[#102E31] to-[#157D87] md:text-[88px] md:text-left md:leading-[100px]">
          Our Latest <br /> Research
        </h2>

        {/* Research Grid */}
        <div className="grid gap-10 mt-10 md:grid-cols-3">
          {researchItems.map((item, index) => (
            <div
              key={index}
              className={`border-t pt-5 ${
                item.highlight ? "border-black" : "border-gray-500"
              }`}
            >
              <h3 className="mb-3 text-2xl font-semibold">{item.title}</h3>
              <p className="leading-relaxed text-gray-700 text-md">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Button */}
        <div className="flex justify-center mt-14">
          <div>
            <p
              href="#"
              className="flex items-center justify-center py-1 pl-2 pr-4 font-medium text-white transition bg-black rounded-full hover:bg-teal-800"
            >
              <span className="px-3 py-2 mr-2 text-xl text-black bg-white border border-black rounded-full">
                →
              </span>
              View All Research
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestResearch;
